import { Box, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';
import { Resource } from 'json-api-hooks';
import React, { FormEventHandler, ReactNode } from 'react';
import { FormProvider, UseFormReturn } from 'react-hook-form';

import Button from '../././Button';

import FormErrors from './FormErrors';
import FormFields from './FormFields';
import FormFooter from './FormFooter';
import { FormFieldDefinition } from './ResourceForm';

const Form = ({
  defaultValues,
  description,
  fields,
  loading,
  methods,
  onClose,
  onSubmit,
  resource,
  storageKey,
  submitLabel,
}: {
  defaultValues?: Record<string, unknown>;
  description?: ReactNode;
  fields: Array<FormFieldDefinition | undefined>;
  loading?: boolean;
  methods: UseFormReturn;
  onClose?: () => void;
  onSubmit: FormEventHandler;
  resource?: Resource;
  storageKey?: string;
  submitLabel: string;
}) => {
  const theme = useTheme();
  const crammed = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <FormProvider {...methods}>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5em',
          width: '100%',
        }}
        onSubmit={onSubmit}
      >
        {description}
        <FormFields
          defaultValues={defaultValues}
          fields={fields.filter(Boolean) as FormFieldDefinition[]}
          resource={resource}
          storageKey={storageKey}
        />
        <FormErrors />
        <FormFooter>
          {onClose && (
            <Button icon={crammed ? 'close' : ''} variant="text" onClick={onClose}>
              {!crammed && t('form.cancel')}
            </Button>
          )}
          <Button icon={crammed ? 'check' : ''} loading={loading} type="submit">
            {!crammed && submitLabel}
          </Button>
        </FormFooter>
      </Box>
    </FormProvider>
  );
};

export default Form;
